import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
    tipo: ['receptores'],
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.app.receptores.archivos = {
      ...state.app.receptores.archivos,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.receptores.archivos.data = {
      ...state.app.receptores.archivos.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.app.receptores.archivos = {
      ...state.app.receptores.archivos,
      busy: true,
      pagination: {
        ...state.app.receptores.archivos.pagination,
        ...params,
      },
    };
  });

  try {
    const body = {
      ...store.state.app.receptores.archivos.pagination,
      ...params,
      links: undefined,
    };

    const response = await Http.get(`/api/excel-files`, { params: body });

    store.setState((state) => {
      state.app.receptores.archivos = {
        ...state.app.receptores.archivos,
        ...initialState,
        data: response.data,
        pagination: {
          ...state.app.receptores.archivos.pagination,
          ...response.meta.pagination,
          links: undefined,
          limit: body.limit || state.app.receptores.archivos.pagination.limit,
        },
        filters: {
          ...state.app.receptores.archivos.filters,
          ...body,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.archivos.busy = false;
      state.app.receptores.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.archivos = {
      ...initialState,
    };
  });
};

const ReceptorFileListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default ReceptorFileListStore;
